import React, { useEffect, useRef, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import axios from "axios";
import exportToExcel from "../Report/ExportExcel";

const passengerTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const BookedTrips = ({ prRef }) => {
  const [data, setData] = useState([]);

  const getReservations = async () => {
    const response = await axios
      .get("reservations/")
      .then((res) => {
        const newRes = res.data.map((re) => {
          return {
            ...re,
            passenger: {
              ...re.passenger,
              name: re.passenger.firstName + " " + re.passenger.lastName,
            },
          };
        });
        setData(newRes);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    getReservations();
  }, []);
  const columns = [
    "Id",
    "Passenger Name",
    "Passenger Phone",
    "Pick Up Location Latitude",
    "Pick Up Location Longitude",
    "Destination Location Lat",
    "Destination Location Long",

    "Status",
  ];

  return (
    <div ref={prRef}>
      <Header
        title={"Booked Trips Information"}
        subTitle={""}
      />
      <table style={passengerTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((trip, index) => (
            <tr key={index}>
              <td style={thTdStyle}>{trip.id}</td>
              <td style={thTdStyle}>{trip?.passenger?.name}</td>
              <td style={thTdStyle}>{trip?.passenger?.phoneNumber}</td>

              <td style={thTdStyle}>{trip.pickUpLocationLatitude}</td>
              <td style={thTdStyle}>{trip.pickUpLocationLongitude}</td>

              <td style={thTdStyle}>{trip.destinationLocationLatitude}</td>
              <td style={thTdStyle}>{trip.destinationLocationLongitude}</td>
              <td style={thTdStyle}>{trip.status}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Footer />
    </div>
  );
};

export const exportExcelBookedTrips = async () => {
  const getReservations = async () => {
    const response = await axios
      .get("reservations/")
      .then((res) => {
        const newRes = res.data.map((re) => {
          return {
            Id: re.id,
            "Passenger Name":
              re.passenger.firstName + " " + re.passenger.lastName,
            "Passenger Phone": re.passenger.phoneNumber,
            "Pick Up Location Latitude": re.pickUpLocationLatitude,
            "Pick Up Location Longitude": re.pickUpLocationLongitude,
            "Destination Location Latitude": re.destinationLocationLatitude,
            "Destination Location Longitude": re.destinationLocationLongitude,
            Status: re.status,
          };
        });

        // Create Excel with the specified columns
        exportToExcel(newRes, "reservations", [
          "Id",
          "Passenger Name",
          "Passenger Phone",
          "Pick Up Location Latitude",
          "Pick Up Location Longitude",
          "Destination Location Latitude",
          "Destination Location Longitude",
          "Status",
        ]);
      })
      .catch((err) => {});
  };
  getReservations();
};

export default BookedTrips;
